import {
    useMemo,
} from 'react'

import useFieldsWithClassNames from 'app/hooks/useFieldsWithClassName'
import useEnumValues from 'app/hooks/useEnumValues'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import {
    showLTL, showFTL, isDeliveryRoad,
} from 'app/Apps/Pricing/utils/utils'
import useAQuoteContext from 'app/Apps/AccountManagement/AQuotes/AQuoteContext/useAQuoteContext'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'

import {
    AssignPricingLaneGroupResponse,
} from '../../../AQuotes.types'

import getFields from './AQuoteLaneGroupOverview.fields'
import useStyles from './AQuoteLaneGroupOverview.styles'

const AQuoteLaneGroupOverview = ({
    data,
}: { data: AssignPricingLaneGroupResponse }) => {
    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()
    const {
        isPerformanceQualification,
    } = useAQuoteContext()

    const {
        LaneGroups: LaneGroupsRoutes,
    } = usePricingRoutes()

    const value = useMemo(() => {
        return {
            ...data?.laneGroup,
            ...data?.quote,
            ...data?.requestedOpportunity,
            ...data?.requestedOpportunity?.opportunity,
            baseLeaseDays: (data?.quote?.baseLeaseDays || []).join(';'),
            changedOn: data?.laneGroup?.changedOn,
            id: data?.laneGroup?.id,
            isPerformanceQualification,
        }
    }, [
        data,
        isPerformanceQualification,
    ])

    const fields = useFieldsWithClassNames(
        getFields({
            getAllowedValues,
            isDeliveryRoad: isDeliveryRoad(value?.deliveryServiceType),
            showFTL: showFTL(value?.transportModeRoad),
            showLTL: showLTL(value?.transportModeRoad),
            laneGroupLink: generateSkyNetLink({
                domainPath: LaneGroupsRoutes.Overview.path,
                params: {
                    key: data?.laneGroup?.id,
                },
            }),
        }), classes,
    )

    return (
        <DomainObjectForm
            name="AQuoteLaneGroup"
            value={value}
            className={classes.gridWrapper}
            fields={fields}
            disabled
            exists
        />
    )
}

export default AQuoteLaneGroupOverview
